import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Typography,
  TableBody,
  Box,
  IconButton,
  Button,
  TableFooter,
  Grid,
  Select,
  MenuItem,
  Chip,
  Pagination,
  Stack,
  Collapse,
  Tooltip,
  CircularProgress,
  Link,
  Radio,
  Dialog,
  Slide,
} from '@mui/material';
import LinearProgress, { LinearProgressProps } from '@mui/material/LinearProgress';
import { clearPersistForSelectedDomain, deleteScheduleScan, pauseScan, resumeScan, setPersist, setShowScanDomainDialog, setToastMessage, startManualScan } from 'src/store/my_pages/app';
import { setCurrentPageSizeOfTabs, setCurrentPaginationOfTheTab, setCurrentTab } from 'src/store/my_pages/summary';
import { setInitialtUserJobScheduleId, setUserJobScheduleIdFromResData } from 'src/functions/general';
import { TableRow_Custom } from 'src/components/shared/table-related/TableRow_Custom';
import { IconPlayerPlay, IconPlayerPause, IconProgress } from '@tabler/icons-react';
import ConfirmationDialog from 'src/components/shared/ConfirmationDialog';
import { KeyboardArrowDown, KeyboardArrowRight, KeyboardArrowUp } from '@mui/icons-material';
import IconTickorX from 'src/components/shared/form-inputs/IconTickorX';
import { ScanFrequencyType, ScanMainNameType } from 'src/utils/enums';
import { MdDeleteOutline, MdModeEditOutline } from 'react-icons/md';
import { fetchSingleApi, independent_initializers } from 'src/App';
import React, { useEffect, useState, useMemo } from 'react';
import BlankCard from 'src/components/shared/cards/BlankCard';
import { useSelector } from 'react-redux';
import { AppState, dispatch } from 'src/store/Store';
import Spinner from 'src/views/spinner/Spinner';
import { ThemeSettings } from 'src/theme/Theme';
import { useCookies } from 'react-cookie';
import { format, set } from 'date-fns';
import { collapsibles_font_variant, table_font_variant } from 'src/config/muiVars';
import { useTranslation } from 'react-i18next';
import { apiConfig, getApiUrl } from 'src/config/apiConfig';
import scan_screenshot_placeholder from 'src/assets/images/placeholders/scan-screenshot.webp';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import { LuBadgeMinus, LuBadgePlus } from 'react-icons/lu';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import { RiInformationLine } from 'react-icons/ri';
import CrsScoreCell from './CrsScoreCell';

// const Spinner = Loadable(lazy(() => import('src/views/spinner/Spinner')));

const TargetsTable = ({ tabId }) => {
  const targetsReducer = useSelector((state: AppState) => state.targetsReducer);
  const schedule_scan = useSelector((state: AppState) => state.appGeneralReducer.persist.schedule_scan);
  const scan_type_packages = useSelector((state: AppState) => state.appGeneralReducer.persist.scan_type_packages);
  const { persist, allSearchTexts, showScanDomainDialog } = useSelector((state: AppState) => state.appGeneralReducer);
  const [scanningStatesofTargets, setScanningStatesofTargets] = useState<any>({});
  const [first_render, setfirst_render] = useState(true);

  // Get all unique scan types from packages
  const allScanTypes = useMemo(() => {
    if (!scan_type_packages?.length) return [];
    const allTypes = scan_type_packages.reduce((acc: any[], pkg: any) => {
      if (pkg.scanTypes?.length) {
        pkg.scanTypes.forEach((type: any) => {
          if (!acc.find((t) => t.id === type.id)) {
            acc.push(type);
          }
        });
      }
      return acc;
    }, []);
    return allTypes;
  }, [scan_type_packages]);

  const [rowsPerPage, setRowsPerPage] = useState(targetsReducer.currentPageSizeOfTabs[tabId]);
  const [page, setPage] = useState(targetsReducer.currentPaginationOfTabs[tabId]);
  const [rows, setRows] = useState<any[]>(schedule_scan || []);
  const [openRows, setOpenRows] = useState<string[]>([]);
  const [selectedCheckboxItems, setselectedCheckboxItems] = useState<any>([]);
  const scanType_ChipColors = ['', 'warning', 'info', 'success'] as const;
  const [isloading_action, setisloading_action] = useState(false);
  const [manualScanLoadingStates, setManualScanLoadingStates] = useState<Record<string, boolean>>({});
  const [progressCache, setProgressCache] = useState<Record<string, number>>({});

  const [cookie, ,] = useCookies();
  // const dispatch = useDispatch();
  const [open_screenshot, setopen_screenshot] = useState(false);
  const [clicked_screenshotpath, setclicked_screenshotpath] = useState<string>('');

  // edit row
  const [showEditFormDialog, setShowEditFormDialog] = useState<boolean>(false);
  const [clickedRowId, setClickedRowId] = useState<number | string | null>(null);
  // delete row
  const [showDelConfirmation, setShowDelConfirmation] = useState<any>(false);

  // Translations
  const { t } = useTranslation<'translation'>();
  const language_redux = useSelector((state: AppState) => state.customizer.isLanguage);

  const handleChangePage = async (_event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    setPage(newPage);
    dispatch(
      setCurrentPaginationOfTheTab({
        tabId: tabId,
        pagination: page,
      }),
    );
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    dispatch(
      setCurrentPageSizeOfTabs({
        tabId: tabId,
        pageSize: parseInt(event.target.value, 10),
      }),
    );
    setPage(0);
  };

  const handleRowToggle = (id: string) => {
    setOpenRows((prevOpenRows) => {
      const isOpen = prevOpenRows.includes(id);
      return isOpen ? prevOpenRows.filter((row) => row !== id) : [...prevOpenRows, id];
    });
  };

  const isChecked = (id) => {
    return selectedCheckboxItems?.findIndex((item) => item.id === id) !== -1;
  };

  useEffect(() => {
    // Set the current tab on initial render
    dispatch(setCurrentTab(tabId));
  }, []);

  useEffect(() => {
    // Fetch data on initial render
    // handleGetTableData();
    setRowsPerPage(targetsReducer.currentPageSizeOfTabs[tabId]);
  }, [targetsReducer.currentTab, targetsReducer.currentPaginationOfTabs[tabId], targetsReducer.currentPageSizeOfTabs[tabId]]);

  useEffect(() => {
    //? Set rows when data is fetched
    setRows(schedule_scan || []);

    //? Open the row if there is only one
    if (schedule_scan?.length === 1) {
      const theRow = schedule_scan?.[0];
      if (!selectedCheckboxItems?.some((i: any) => i.id === theRow.id)) {
        setTimeout(() => {
          setselectedCheckboxItems([theRow]);
        }, 100);
      }
    }
  }, [schedule_scan]);

  // Maintain a monotonic progress cache per target using only progressPercent or completion
  useEffect(() => {
    if (!Array.isArray(schedule_scan)) return;

    setProgressCache((prev) => {
      const next: Record<string, number> = { ...prev };

      schedule_scan.forEach((item: any) => {
        const id = String(item?.id ?? '');
        const status = item?.status || {};

        if (status?.isCompleted === true) {
          next[id] = 100;
          return;
        }

        if (typeof status?.progressPercent === 'number') {
          const clamped = Math.min(Math.max(status.progressPercent, 0), 100);
          const previous = prev?.[id] ?? 0;
          // If progressPercent is 0 and scan is not completed, reset cache to 0
          if (clamped === 0 && !status?.isCompleted) {
            next[id] = 0;
          } else {
            next[id] = Math.max(previous, clamped);
          }
        } else {
          // If no progressPercent yet and scan is not completed, reset to 0
          if (!status?.isCompleted) {
            next[id] = 0;
          }
        }
      });

      return next;
    });
  }, [schedule_scan]);

  useEffect(() => {
    // Update to fetch data on page change
    dispatch(
      setCurrentPaginationOfTheTab({
        tabId,
        pagination: page,
      }),
    );
  }, [page, rowsPerPage]);

  useEffect(() => {
    // Sync page when page from reducer is changed
    setPage(targetsReducer.currentPaginationOfTabs[tabId]);
  }, [targetsReducer.currentPaginationOfTabs, targetsReducer.currentTab]);

  const calculatePaginationRange = () => {
    const startRow = page * rowsPerPage + 1;
    const endRow = Math.min((page + 1) * rowsPerPage, targetsReducer?.fetchedTableData[tabId]?.total || 1);
    if (!startRow || !endRow) {
      return false;
    }
    return `${startRow}-${endRow > startRow ? endRow : startRow + rowsPerPage - 1} of ${targetsReducer?.fetchedTableData[tabId]?.total || 1}`;
  };

  //   const writeAuthList = [apiConfig.userRoles.Admin];
  //   const hasWriteAuth = IsAuthorized({
  //     role_limitations: writeAuthList,
  //   });
  const hasWriteAuth = true; // TODO

  const deleteRow = async () => {
    const res = await dispatch(deleteScheduleScan(String(clickedRowId)) as any).unwrap();
    if (res.status === 200) {
      //? To handle via fetching:
      // const scanList = await fetchSingleApi('schedule_scan');
      // localStorage.removeItem('selectedDomain');
      // if (scanList?.data?.length) setUserJobScheduleIdFromResData(scanList?.data);
      // await independent_initializers();

      //? To handle statically:
      // The Redux reducer will automatically remove the item from schedule_scan
      // Check if the deleted target was the active one and update accordingly
      const deletedTarget = schedule_scan?.find((i) => i.id === clickedRowId);
      const isActiveTargetDeleted = persist?.userJobScheduleId === deletedTarget?.lastWebsiteVulnerabilityId;
      if (isActiveTargetDeleted) {
        // Clear action plans and other domain-specific data before switching to new domain
        dispatch(clearPersistForSelectedDomain());
        // Get the updated schedule_scan after deletion (reducer will have already removed it)
        const updatedScheduleScan = schedule_scan?.filter((i) => i.id !== clickedRowId);
        setUserJobScheduleIdFromResData(updatedScheduleScan);
      }
      dispatch(setToastMessage({ msg: 'Target deleted successfully', iconKey: 'check_circle', color: 'success', duration: 3000 }));
    }
  };

  const handleClickCheckbox = async (event: React.MouseEvent<unknown>, row: any) => {
    if (!row?.id) return;
    setselectedCheckboxItems((prev) => {
      //? To select multiple rows:
      if (selectedCheckboxItems?.findIndex((item) => item.id === row.id) !== -1) {
        return selectedCheckboxItems.filter((i) => i.id !== row.id);
      } else {
        return [...prev, row];
      }
      //? To select single row:
      // if (selectedCheckboxItems?.findIndex((item) => item.id === row.id) !== -1) {
      //   return [];
      // } else {
      //   return [row];
      // }
    });
  };

  const theme = ThemeSettings();

  //? FE table filter
  const tableKey = 'targets';
  useEffect(() => {
    const searchText: string = allSearchTexts?.[tableKey]?.toLowerCase();
    if (!searchText) {
      setRows(schedule_scan || []);
    } else {
      const searchKey = 'url';
      const newRows = (schedule_scan || []).filter((item: any) => item?.[searchKey]?.toLowerCase()?.includes(searchText?.toLowerCase()));
      setRows(newRows);
    }
  }, [allSearchTexts?.[tableKey], schedule_scan]);

  useEffect(() => {
    if (!scan_type_packages || !scan_type_packages.length) {
      fetchSingleApi('scan_type_packages');
    }
  }, []);

  useEffect(() => {
    if (first_render) {
      setfirst_render(false);
    }
  }, [schedule_scan]);

  // TESTING
  // useEffect(() => {
  //   const getApiKey = async () => {
  //     const res = await axiosIn.get(getApiUrl(apiConfig.api_key_getpost));
  //     console.log(res);
  //   };
  //   setTimeout(() => {
  //     getApiKey();
  //   }, 1000);
  // }, []);

  return (
    <BlankCard sx={{ padding: '0', margin: 0 }}>
      {/* Update a row Form | popup */}
      {/* <>{showEditFormDialog && <CustomFormDialog open={true} setOpenDialog={setShowEditFormDialog} itemId={clickedRowId} rowData={rows.find((i) => i.id === clickedRowId)} />}</> */}
      {/* {showScanDomainDialog && <AddNewDomainDialog form_type="EDIT" editData={rows.find((i) => i.id === clickedRowId)} open={true} setOpenDialog={() => dispatch(setShowScanDomainDialog())} />} */}
      <ConfirmationDialog isOpen={showDelConfirmation} setIsOpen={setShowDelConfirmation} onConfirm={() => deleteRow()} title="Delete Confirmation" description="Are you sure you want to delete?" />
      <TableContainer component={Paper} sx={{ padding: '0', margin: 0 }}>
        <Table
          aria-label="collapsible table"
          sx={{
            whiteSpace: {
              xs: 'nowrap',
              sm: 'unset',
            },
            '& .MuiTableCell-root': {
              py: '3px',
              px: { xs: 1, lg: 1 },
            },
            margin: 0,
            // bgcolor:"red"
          }}
        >
          <TableHead>
            <TableRow sx={{ verticalAlign: 'center', backgroundColor: theme.palette.purple.A200, height: '3.5rem' }}>
              <TableCell width={'26px'} title="selected">
                {/* <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', lineHeight: '20px' }}>{selectedCheckboxItems?.length ? `( ${selectedCheckboxItems?.length} )` : null}</Box> */}
              </TableCell>
              {['Target', 'Scan Type', 'Scan Frequency', 'Actions', 'Last Execution Time', 'Next Scan', 'Manual Scan'].map((col: string, index: number) => (
                <TableCell key={index} content="center" align="center">
                  <Typography variant={table_font_variant} fontWeight="600">
                    {col}
                  </Typography>
                </TableCell>
              ))}
              <TableCell content="center" align="center">
                <Stack direction="row" spacing={0.5} alignItems="center" justifyContent="center">
                  <Typography variant={table_font_variant} fontWeight="600">
                    CRS
                  </Typography>
                  <Tooltip title="Cyber Risk Score (CRS): an overall 0–10 cyber risk rating based on your scan findings and company profile. Lower is safer." enterDelay={300}>
                    <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', color: 'text.secondary', cursor: 'help' }}>
                      <RiInformationLine size={16} />
                    </Box>
                  </Tooltip>
                </Stack>
              </TableCell>
              <TableCell sx={{ minWidth: '50px' }} title="Action buttons">
                <Typography variant={table_font_variant} fontWeight="600"></Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          {rows?.length ? (
            <TableBody>
              {Array.isArray(rows) &&
                rows?.map((row, j: number) => (
                  <React.Fragment key={row?.id || row?.url || j}>
                    <TableRow
                      hover
                      onClick={(event) => {
                        // handleRowToggle(row?.id?.toString());
                        handleClickCheckbox(event, row);
                        event.stopPropagation();
                      }}
                      style={{ position: 'relative', fontWeight: '800 !important' }}
                    >
                      <TableCell>
                        <Box width={'26px'} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '26px', px: 3 }}>
                          {/* <Checkbox
                            color="info"
                            onClick={(event) => handleClickCheckbox(event, row)}
                            checked={isChecked(row?.id) || false}
                            inputProps={{
                              'aria-labelledby': row?.id?.toString(),
                            }}
                            sx={{ padding: '0px !important', margin: '0px !important', maxWidth: '0px', width: '0px', opacity: '90%' }}
                          /> */}
                          <IconButton aria-label="expand row" size="small" onClick={(event) => handleClickCheckbox(event, row)}>
                            {isChecked(row?.id) ? <KeyboardArrowDown /> : <KeyboardArrowRight />}
                          </IconButton>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, position: 'relative', left: 0 }}>
                          {/* {row?.id === persist?.userJobScheduleId && <Badge variant={'dot'} color="primary" />} */}
                          {row?.lastWebsiteVulnerabilityId === persist?.userJobScheduleId && (
                            <Radio
                              size="small"
                              checked={true}
                              color="primary"
                              inputProps={{
                                'aria-labelledby': 'radio-label',
                              }}
                              sx={{
                                '&.MuiButtonBase-root': {
                                  width: '16px',
                                  height: '16px',
                                  margin: 0,
                                  padding: 0,
                                  // bgcolor: "red"
                                },
                              }}
                            />
                          )}
                          <Box>
                            <Stack direction={'row'} gap={1} alignItems={'center'}>
                              <Tooltip
                                title={
                                  <Typography variant="body1" fontSize={14}>
                                    Select this domain
                                    {row?.name ? (
                                      <span style={{ fontStyle: 'italic', fontWeight: 600, margin: '4px', display: 'block' }}>
                                        <span style={{ margin: '5px' }}>❛ {row?.name} ❜</span>
                                      </span>
                                    ) : null}
                                  </Typography>
                                }
                                enterDelay={200}
                              >
                                <span>
                                  <Link
                                    component={'button'}
                                    underline="hover"
                                    color={'text.primary'}
                                    variant={table_font_variant}
                                    onClick={async (e) => {
                                      e.stopPropagation();
                                      const res = await setInitialtUserJobScheduleId(row?.lastWebsiteVulnerabilityId);
                                      if (!res) return;
                                      dispatch(setToastMessage({ msg: 'Selected domain is changed', iconKey: 'check_circle', color: 'success', duration: 4000 }));
                                      await fetchSingleApi('schedule_scan', true);
                                    }}
                                    sx={{ textAlign: 'left', width: '100%' }}
                                  >
                                    {row?.url}
                                  </Link>
                                </span>
                              </Tooltip>
                              {/* Linear progress with percent label */}
                              {row?.status?.isCompleted !== true && (
                                <Tooltip title={'Analysis running...'}>
                                  {(() => {
                                    if (!row?.status?.progressPercent) {
                                      return <LinearProgress variant="indeterminate" sx={{ width: '100%', minWidth: '100px', maxWidth: '160px' }} />;
                                    }
                                    const id = String(row?.id ?? '');
                                    // Use cached monotonic value; if not available yet, show 0 until first progressPercent arrives
                                    const percent = progressCache?.[id] ?? 0;
                                    const clamped = Math.min(Math.max(percent, 0), 100);

                                    return (
                                      <Box sx={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'center', gap: 1 }}>
                                        <LinearProgress
                                          variant="determinate"
                                          value={clamped}
                                          sx={{
                                            flex: 1,
                                            ml: 2,
                                            height: 8,
                                            borderRadius: 4,
                                            minWidth: 80,
                                            maxWidth: '160px',
                                            backgroundColor: 'grey.300',
                                          }}
                                        />
                                        <Typography variant="caption" sx={{ minWidth: 32, textAlign: 'right', fontWeight: 600 }}>
                                          {clamped}%
                                        </Typography>
                                      </Box>
                                    );
                                  })()}
                                </Tooltip>
                              )}
                              {/* {row?.status?.screenshotUrl && (
                                <IconButton
                                  title="Display screenshot"
                                  aria-label="Display screenshot"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setclicked_screenshotpath(row?.status?.screenshotUrl || '');
                                    setopen_screenshot(true);
                                  }}
                                >
                                  <RiScreenshot2Fill size={20} color="grey" />
                                </IconButton>
                              )} */}
                            </Stack>
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell align="center">
                        <Tooltip title={''} enterDelay={500}>
                          <Chip
                            label={row?.scanPackageDetail?.name || ''}
                            size="small"
                            color={scanType_ChipColors?.[ScanMainNameType?.[row?.scanPackageDetail?.name]] || 'primary'}
                            // sx={{ // this is for lighthouse contast ratio score, but not looking good
                            //   height: "auto",
                            //   py: "1px",
                            //   px: "4px",
                            //   letterSpacing: '1px',
                            //   // fontWeight: 600,
                            //   // fontSize: '12px',
                            //   bgcolor: (theme) => theme.palette?.[scanType_ChipColors?.[ScanMainNameType?.[row?.scanPackageDetail?.name]] || 'primary'].dark, // ✅ Correct
                            //   color: (theme) => theme.palette.success.contrastText // Automatically white/black
                            // }}
                          />
                        </Tooltip>
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1.5 }}>
                          <Typography variant={table_font_variant}>{ScanFrequencyType?.[row?.scanFrequency] || row?.scanFrequency}</Typography>
                        </Box>
                      </TableCell>
                      <TableCell align="center">
                        {/* OLD */}
                        {/* {row?.isPaused && !row?.isManualStartAvailable && (
                          <IconButton  aria-label="expand"
                            sx={{ fontSize: 16, '&:hover': { textDecoration: 'underline' } }}
                            title="Resume"
                            onClick={async (e) => {
                              e.stopPropagation();
                              const res = await dispatch(resumeScan({ scanId: row.id }) as any).unwrap();
                              // await dispatch(fetchTargetsTable({}) as any);
                              await fetchSingleApi('schedule_scan', true);
                              if (res.status === 200) setRows((prev) => prev.map((i) => (i.id === row.id ? { ...i, isPaused: false } : i)));
                            }}
                          >
                            <IconPlayerPlay />
                          </IconButton>
                        )} */}
                        {/* {!row?.isPaused && !row?.isManualStartAvailable && (
                          <IconButton  aria-label="expand"
                            sx={{ fontSize: 16, '&:hover': { textDecoration: 'underline' } }}
                            title="Pause"
                            onClick={async (e) => {
                              e.stopPropagation();
                              const res = await dispatch(pauseScan({ scanId: row.id }) as any).unwrap();
                              // await dispatch(fetchTargetsTable({}) as any);
                              await fetchSingleApi('schedule_scan', true);
                              if (res.status === 200) setRows((prev) => prev.map((i) => (i.id === row.id ? { ...i, isPaused: true } : i)));
                            }}
                          >
                            <IconPlayerPause />
                          </IconButton>
                        )} */}
                        {/* {row?.isManualStartAvailable && '-'} */}
                        {row?.scanFrequency === 0 ? (
                          <Typography variant={table_font_variant} title="One time scan does not have this option">
                            -
                          </Typography>
                        ) : row?.isPaused ? (
                          <Tooltip title={`Resume`} enterDelay={500}>
                            <IconButton
                              sx={{ fontSize: 16, '&:hover': { textDecoration: 'underline' } }}
                              onClick={async (e) => {
                                e.stopPropagation();
                                setisloading_action(row.id);
                                try {
                                  const res = await dispatch(resumeScan({ scanId: row.id }) as any).unwrap();
                                  if (res.status === 200) {
                                    setRows((prev) => prev.map((i) => (i.id === row.id ? { ...i, isPaused: false } : i)));
                                  } else {
                                    dispatch(setToastMessage({ msg: res.errMsg, iconKey: 'error', color: 'error', duration: 4000 }));
                                  }
                                } catch (error) {
                                } finally {
                                  setisloading_action(false);
                                }
                              }}
                              aria-label="resume"
                            >
                              {isloading_action === row.id ? <CircularProgress size={20} /> : <IconPlayerPlay />}
                            </IconButton>
                          </Tooltip>
                        ) : (
                          <Tooltip title={`Pause ${Number(row?.scanFrequency) > -1 ? ScanFrequencyType?.[row?.scanFrequency]?.toLowerCase() : '-'} scans`} enterDelay={500}>
                            <IconButton
                              sx={{ fontSize: 16, '&:hover': { textDecoration: 'underline' } }}
                              onClick={async (e) => {
                                e.stopPropagation();
                                setisloading_action(row.id);
                                try {
                                  const res = await dispatch(pauseScan({ scanId: row.id }) as any).unwrap();
                                  if (res.status === 200) {
                                    setRows((prev) => prev.map((i) => (i.id === row.id ? { ...i, isPaused: true } : i)));
                                  } else {
                                    dispatch(setToastMessage({ msg: res.errMsg, iconKey: 'error', color: 'error', duration: 4000 }));
                                  }
                                } catch (error) {
                                } finally {
                                  setisloading_action(false);
                                }
                              }}
                              aria-label="pause"
                            >
                              {isloading_action === row.id ? <CircularProgress size={20} /> : <IconPlayerPause />}
                            </IconButton>
                          </Tooltip>
                        )}
                      </TableCell>
                      <TableCell align="center">
                        <Typography variant={table_font_variant} sx={{ whiteSpace: 'nowrap', color: 'text.secondary', fontSize: 'small' }}>
                          {row?.lastExecutionTime && !row?.lastExecutionTime.includes('0001-01-01T') ? format(new Date(row.lastExecutionTime), 'dd.MM.yyyy - hh:mm') : '-'}
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Typography variant={table_font_variant} sx={{ whiteSpace: 'nowrap', color: 'text.secondary', fontSize: 'small' }}>
                          {row?.nextExecutionTime && !row?.nextExecutionTime.includes('0001-01-01T') ? format(new Date(row.nextExecutionTime), 'dd.MM.yyyy - hh:mm') : '-'}
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        {row?.scanFrequency === 0 ? (
                          <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} sx={{ margin: 'auto' }}>
                            <Typography sx={{ textAlign: 'center' }} variant={table_font_variant} title="One time scan does not have this option">
                              -
                            </Typography>
                          </Stack>
                        ) : row?.status?.isCompleted === true ? (
                          <Tooltip title={row?.isManualStartAvailable ? `` : `Manual scan is only available once every 24 hours.`} enterDelay={500}>
                            <span>
                              <IconButton
                                disabled={!row?.isManualStartAvailable || manualScanLoadingStates[row.id]}
                                sx={{ fontSize: 16, '&:hover': { textDecoration: 'underline' } }}
                                onClick={async (e) => {
                                  e.stopPropagation();
                                  setManualScanLoadingStates((prev) => ({ ...prev, [row.id]: true }));

                                  try {
                                    const res = await dispatch(startManualScan({ scanId: row.id }) as any).unwrap();
                                    if (res.status === 500) {
                                      dispatch(setToastMessage({ msg: "Can't start manual scan for now", iconKey: 'error', color: 'error', duration: 4000 }));
                                    } else if (res.status === 200) {
                                      dispatch(setToastMessage({ msg: 'Manual scan started', iconKey: 'check_circle', color: 'success', duration: 4000 }));

                                      const scanIndex = persist?.schedule_scan?.findIndex((scan: any) => scan.id === row.id);
                                      if (scanIndex > -1) {
                                        const updatedScans = [...(persist?.schedule_scan || [])];
                                        // Use the current scan data from the store, not the stale row object
                                        const currentScan = updatedScans[scanIndex];
                                        updatedScans[scanIndex] = {
                                          ...currentScan,
                                          isManualStartAvailable: false,
                                          status: {
                                            ...currentScan?.status,
                                            selectedScans: {},
                                            isCompleted: false,
                                            progressPercent: 0,
                                            currentState: 'Scanning',
                                          },
                                        };
                                        dispatch(setPersist({ key: 'schedule_scan', value: updatedScans }));
                                        // Reset local progress cache to ensure UI shows 0%
                                        setProgressCache((prev) => ({ ...prev, [row.id]: 0 }));
                                      }
                                    } else if (res.status === 400) {
                                      dispatch(setToastMessage({ msg: res.errMsg || "Can't start manual scan for now", iconKey: 'error', color: 'error', duration: 4000 }));
                                    }
                                  } catch (error) {
                                    console.log('error: ', error);
                                    dispatch(setToastMessage({ msg: 'Failed to start manual scan', iconKey: 'error', color: 'error', duration: 4000 }));
                                  } finally {
                                    setManualScanLoadingStates((prev) => ({ ...prev, [row.id]: false }));
                                  }
                                }}
                                aria-label="scan now"
                              >
                                {manualScanLoadingStates[row.id] ? <CircularProgress size={16} /> : 'Scan Now'}
                              </IconButton>
                            </span>
                          </Tooltip>
                        ) : (
                          <Tooltip title={row?.manualStartTime ? `Scanning...\nStarted at: ${format(new Date(row.manualStartTime), 'dd.MM.yyyy - hh:mm')}` : 'Scanning...'} enterDelay={500}>
                            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                              <IconProgress />
                            </Box>
                          </Tooltip>
                        )}
                      </TableCell>
                      <TableCell align="center">
                        <CrsScoreCell row={row} />
                      </TableCell>
                      {hasWriteAuth && (
                        <TableCell align="center">
                          <Box sx={{ display: 'flex', gap: '5px', justifyContent: 'center' }}>
                            {row?.scanFrequency === 0 ? (
                              <Typography sx={{ width: '31px', textAlign: 'center' }} variant={table_font_variant} title="One time scan does not have this option"></Typography>
                            ) : (
                              <Tooltip title={`Edit`} enterDelay={500}>
                                <Button
                                  onClick={(e) => {
                                    setClickedRowId(row?.id);
                                    // setShowEditFormDialog(true);
                                    dispatch(setShowScanDomainDialog({ ...row, form_type: 'EDIT' }));
                                    e.stopPropagation();
                                  }}
                                  variant="text"
                                  color="info"
                                  sx={{ padding: '3px', marginRight: '5px', minWidth: 'min-content' }}
                                >
                                  <MdModeEditOutline size={20} />
                                </Button>
                              </Tooltip>
                            )}
                            <Tooltip title={`Delete`} enterDelay={500}>
                              <Button
                                onClick={(e) => {
                                  setClickedRowId(row?.id);
                                  setShowDelConfirmation(true);
                                  e.stopPropagation();
                                }}
                                variant="text"
                                color="error"
                                sx={{ padding: '3px', marginRight: '5px', minWidth: 'min-content' }}
                              >
                                <MdDeleteOutline size={20} />
                              </Button>
                            </Tooltip>
                          </Box>
                        </TableCell>
                      )}
                    </TableRow>
                    {/* COLLAPSED CONTENT */}
                    <TableRow_Custom activeIf={isChecked(row?.id)}>
                      <TableCell style={{ padding: 0 }} colSpan={50}>
                        <Collapse in={isChecked(row?.id)} timeout="auto">
                          <Box sx={{ pl: 2, pt: 2, pb: 1 }}>
                            {/* {row?.status?.screenshotUrl && (
                              <IconButton
                                title="Display screenshot"
                                aria-label="Display screenshot"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setclicked_screenshotpath(row?.status?.screenshotUrl || '');
                                  setopen_screenshot(true);
                                }}
                              >
                                <RiScreenshot2Fill size={20} color="grey" />
                              </IconButton>
                            )} */}
                          </Box>
                          <Grid container sx={{ mb: 2, pl: 4, display: 'flex', flexDirection: 'row' }}>
                            {/* Included Scans Column */}
                            <Grid
                              size={{
                                xs: 12,
                                md: 5.5,
                              }}
                            >
                              <Typography color="textSecondary" variant={collapsibles_font_variant} fontWeight="700" sx={{ mb: 2, textTransform: 'capitalize' }}>
                                Included Scans
                              </Typography>
                              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                                {allScanTypes
                                  ?.filter((item: any) => row?.scanPackageDetail?.includedScans?.find((i: any) => i.id === item.id))
                                  .map((item: any, index: number) => (
                                    <Box key={index} sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                      <AddCircleOutlineOutlinedIcon sx={{ color: 'primary.main', fontSize: 20 }} />
                                      <Typography color="textSecondary" variant={collapsibles_font_variant} fontWeight="600" sx={{ textTransform: 'capitalize' }}>
                                        {item?.label}
                                      </Typography>
                                    </Box>
                                  ))}
                                {!allScanTypes?.filter((item: any) => row?.scanPackageDetail?.includedScans?.find((i: any) => i.id === item.id)).length && (
                                  <Typography color="text.disabled" variant={collapsibles_font_variant} sx={{ fontStyle: 'italic' }}>
                                    No included scans
                                  </Typography>
                                )}
                              </Box>
                            </Grid>
                            {/* Excluded Scans Column */}
                            <Grid
                              size={{
                                xs: 12,
                                md: 5.5,
                              }}
                            >
                              <Typography color="textSecondary" variant={collapsibles_font_variant} fontWeight="700" sx={{ mb: 2, textTransform: 'capitalize' }}>
                                Excluded Scans
                              </Typography>
                              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                                {allScanTypes
                                  ?.filter((item: any) => !row?.scanPackageDetail?.includedScans?.find((i: any) => i.id === item.id))
                                  .map((item: any, index: number) => (
                                    <Box key={index} sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                      <RemoveCircleOutlineOutlinedIcon sx={{ color: 'grey.400', fontSize: 20 }} />
                                      <Typography color="textSecondary" variant={collapsibles_font_variant} fontWeight="600" sx={{ textTransform: 'capitalize' }}>
                                        {item?.label}
                                      </Typography>
                                    </Box>
                                  ))}
                                {!allScanTypes?.filter((item: any) => !row?.scanPackageDetail?.includedScans?.find((i: any) => i.id === item.id)).length && (
                                  <Typography color="text.disabled" variant={collapsibles_font_variant} sx={{ fontStyle: 'italic' }}>
                                    No excluded scans
                                  </Typography>
                                )}
                              </Box>
                            </Grid>
                            {/* Tooltip */}

                            <Grid
                              size={{
                                xs: 12,
                                md: 1,
                              }}
                            >
                              <Tooltip
                                title={
                                  <Typography variant={collapsibles_font_variant} fontWeight="400" sx={{ textAlign: 'center' }}>
                                    In order to edit included/exluded scans, you can always edit your target just by clicking the edit button
                                  </Typography>
                                }
                                sx={{ cursor: 'help' }}
                                enterDelay={100}
                              >
                                <IconButton>
                                  <RiInformationLine size={20} />
                                </IconButton>
                              </Tooltip>
                            </Grid>
                          </Grid>
                        </Collapse>
                      </TableCell>
                    </TableRow_Custom>
                  </React.Fragment>
                ))}
            </TableBody>
          ) : (
            <TableBody>
              <TableRow>
                <TableCell style={{ paddingBottom: 0, padding: '20px' }} colSpan={13}>
                  <Typography color="textSecondary" variant={collapsibles_font_variant} fontWeight="800" sx={{ textAlign: 'center', textTransform: 'capitalize' }}>
                    No item is found
                  </Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          )}

          {/* eslint-disable-next-line no-constant-condition */}
          {rows?.length && false ? (
            <TableFooter>
              <TableRow>
                <TableCell colSpan={13}>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-end',
                      gap: '20px',
                      width: '100%',
                      marginTop: '2rem',
                      marginBottom: '10px',
                      paddingRight: '2rem',
                    }}
                  >
                    <Grid
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        gap: '10px',
                      }}
                    >
                      <Typography color="textSecondary" fontWeight="400" sx={{ whiteSpace: 'nowrap' }}>
                        {t('Rows per page:')}
                      </Typography>
                      <Select value={rowsPerPage} onChange={(event) => handleChangeRowsPerPage(event as React.ChangeEvent<HTMLInputElement>)} inputProps={{ 'aria-label': 'rows per page' }}>
                        <MenuItem value={5}>5</MenuItem>
                        <MenuItem value={10}>10</MenuItem>
                        <MenuItem value={25}>25</MenuItem>
                        <MenuItem value={50}>50</MenuItem>
                      </Select>
                    </Grid>
                    {/* --- */}
                    <Grid
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        gap: '10px',
                      }}
                    >
                      {calculatePaginationRange()}
                    </Grid>
                    {/* --- */}
                    <Grid
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        gap: '10px',
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'flex-end',
                          alignItems: 'center',
                        }}
                      >
                        <Stack spacing={2}>
                          <Pagination
                            count={Math.ceil(targetsReducer.fetchedTableData[tabId]?.total / rowsPerPage) || 1} // Total pages
                            page={page + 1} // MUI Pagination is 1-indexed
                            // onChange={(event, newPage) => handleChangePage(event, newPage - 1)} // Adjust for 0-indexed logic
                            variant="outlined"
                            shape="rounded"
                          />
                        </Stack>
                      </Box>
                    </Grid>
                  </Box>
                </TableCell>
              </TableRow>
            </TableFooter>
          ) : null}
        </Table>
      </TableContainer>
      <ScreenShotDialog screenshotProps={{ open_screenshot, setopen_screenshot }} data={clicked_screenshotpath} />
    </BlankCard>
  );
};

export default TargetsTable;

const ScreenShotDialog = ({ screenshotProps, data }) => {
  const { open_screenshot, setopen_screenshot } = screenshotProps;
  return (
    <>
      {screenshotProps && (
        <Dialog sx={{}} open={open_screenshot} TransitionComponent={Slide} keepMounted onClose={() => setopen_screenshot(false)} maxWidth="lg">
          <Box onClick={() => setopen_screenshot(false)}>
            <img
              alt="img"
              width="100%"
              // height="100%"
              style={{ borderRadius: '10px', objectFit: 'cover' }}
              src={data ? apiConfig.PROD_ASSETS_URL + '/' + data : scan_screenshot_placeholder}
            />
          </Box>
        </Dialog>
      )}
    </>
  );
};
